import React from 'react';
import { useTheme } from 'styled-components';

const TwitterIcon = () => {
    const theme = useTheme();
    return (React.createElement("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M6.30515 7.66445L1.54688 13.3357H3.64842L7.31813 8.98715L6.30515 7.66445Z", fill: theme.colors.iconColor }),
        React.createElement("path", { d: "M9.59269 6.29185L8.57769 4.95589L12.1782 0.664551H14.3416L9.59269 6.29185Z", fill: theme.colors.iconColor }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.943359 0.664551L10.6476 13.3357H14.9434L5.31643 0.664551H0.943359ZM3.5098 1.93166L11.2732 12.0685H12.3893L4.68779 1.93166H3.5098Z", fill: theme.colors.iconColor })));
};

export { TwitterIcon as default };
//# sourceMappingURL=TwitterIcon.mjs.map
